import { render } from "./TvmSlideOutKbbTradeValue.vue?vue&type=template&id=7fb008d4&scoped=true"
import script from "./TvmSlideOutKbbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutKbbTradeValue.vue?vue&type=script&lang=js"

import "./TvmSlideOutKbbTradeValue.vue?vue&type=style&index=0&id=7fb008d4&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb008d4"]])

export default __exports__